import React, { Component, Fragment } from "react";
import Sidebar from "react-sidebar";
import FiltersSection from "./components/filtersSection";
import LibraryList from "./list";
import queryString from "query-string";

import "../../assets/scss/pages/app-library.scss";

class LibrarySetup extends Component {
  render() {
    return (
      <div className="_library-application">
        <div
          className={`library-content-overlay ${
            this.props.sidebarOpen ? "show" : ""
            }`}
          onClick={ ()=>this.props.onSetSidebarOpen(false)}>
        </div>
        <div className="sidebar-section">
          <Sidebar
            sidebar={<FiltersSection />}
            docked={this.props.sidebarDocked}
            open={this.props.sidebarOpen}
            sidebarClassName="sidebar-library"
            touch={true}
            contentClassName="sidebar-children d-none">
            ""
          </Sidebar>
        </div>
        <LibraryList
          mainSidebar={(value) => {this.props.onSetSidebarOpen(value)}}
          sidebar={this.props.sidebarOpen}
          toggle={this.props.toggle ? this.props.toggle : false}
          hasShareableFunctionality={this.props.hasShareableFunctionality}
          hasEditableFunctionality={this.props.hasEditableFunctionality}
          hasAddNewFunctionality={this.props.hasAddNewFunctionality}
          contentPicker={this.props.contentPicker}
          contentSharing={this.props.contentSharing}
        />
      </div>
    )
  }
}

export default LibrarySetup;
